import RestClient from './RestClient';
import { Setting } from '../../models';

class Settings extends RestClient {
    constructor() {
        super({
            "model": Setting,
            "entryPoint": "settings",
            "resource": "setting",
            "resources": "settings",
            "id_field": "_id"
        });
    }

    /**
     * Fetch effective settings for a given edition (monoid ⊔ edition.settings).
     * REST-only: does not touch Redux settings state.
     *
     * @param {string} editionId
     * @returns {Promise<object|null>} plain setting document (or null)
     */
    getEffective(editionId) {
        const edition = String(editionId || '').trim();
        if (!edition) {
            return Promise.reject(new Error('Invalid edition id'));
        }

        return this.get('default', null, { edition, nocache: true })
            .then((data) => {
                const setting = data?.setting;
                if (!setting) {
                    return null;
                }
                // Plain data for diffs (Setting is a BaseModel instance).
                return { ...setting };
            });
    }
}

const SettingsApi = new Settings();

export default SettingsApi;
